module.exports = __webpack_public_path__ + "static/thug-fb13705b600fc4806e4ac852b7e5feeb.jpg";